import React, { useState } from "react";
import { Button, Stack } from "@mui/material";
import styles from "./deliveryGuidesTableActionsStyles";
import DeliveryDeliverGuideDialog from "../DeliveryDeliverGuideDialog";

export default function DeliveryGuidesTableActions({ guide, fetchGuides }) {
  const [openDialog, setOpenDialog] = useState(null);

  const handleDialogOpen = (dialogName) => {
    setOpenDialog(dialogName);
  };

  const handleDialogClose = () => {
    setOpenDialog(null);
  };

  return (
    <Stack
      direction="row"
      spacing={0.1}
      style={styles.stack}
    >
      <DeliveryDeliverGuideDialog
        open={openDialog === "DeliverGuideDialog"}
        fetchGuides={fetchGuides}
        onClose={handleDialogClose}
        guide={guide}
      />

      <Button
        variant="outlined"
        onClick={() => handleDialogOpen("DeliverGuideDialog")}
        style={styles.deliveryButton}
      >
        Entregar
      </Button>
    </Stack>
  );
}
